module.exports = __webpack_public_path__ + "static/NightInTheWoods6-bdc7a2d0f77601ddc4ba51aab0fe9b01.png";